"use client";

import React from 'react';

export const LeadDiscoveryAnim = () => (
  <svg viewBox="0 0 400 176" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="ld-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#020617" />
        <stop offset="100%" stopColor="#0c1a3a" />
      </linearGradient>
      <radialGradient id="ld-glow" cx="40%" cy="50%" r="40%">
        <stop offset="0%" stopColor="#4aa198" stopOpacity="0.25" />
        <stop offset="100%" stopColor="#4aa198" stopOpacity="0" />
      </radialGradient>
    </defs>

    <rect width="400" height="176" fill="url(#ld-bg)" />
    {/* Subtle grid */}
    <g stroke="#1e3a5c" strokeWidth="0.5" opacity="0.5">
      {[44, 88, 132].map(y => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}
      {[80, 160, 240, 320].map(x => <line key={x} x1={x} y1="0" x2={x} y2="176" />)}
    </g>

    {/* Glow backdrop */}
    <circle cx="160" cy="88" r="100" fill="url(#ld-glow)" />

    {/* Radar rings — very slow */}
    <g fill="none" stroke="#4aa198" strokeWidth="1">
      <circle cx="160" cy="88" r="45" opacity="0.3" strokeDasharray="3 6">
        <animateTransform attributeName="transform" type="rotate" from="0 160 88" to="360 160 88" dur="32s" repeatCount="indefinite" />
      </circle>
      <circle cx="160" cy="88" r="75" opacity="0.18" strokeDasharray="2 8">
        <animateTransform attributeName="transform" type="rotate" from="360 160 88" to="0 160 88" dur="44s" repeatCount="indefinite" />
      </circle>
    </g>

    {/* Single slow radar sweep */}
    <path d="M160 88 L235 88 A75 75 0 0 1 160 163 Z" fill="#4aa198" opacity="0.07">
      <animateTransform attributeName="transform" type="rotate" from="0 160 88" to="360 160 88" dur="14s" repeatCount="indefinite" />
    </path>

    {/* Detected targets */}
    <g>
      {/* Target A */}
      <circle cx="130" cy="55" r="4" fill="#9bc4b5">
        <animate attributeName="opacity" values="1;0.35;1" dur="5s" repeatCount="indefinite" />
      </circle>
      <circle cx="130" cy="55" r="9" fill="none" stroke="#9bc4b5" strokeWidth="1" opacity="0.5">
        <animate attributeName="r" values="4;12;4" dur="5s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.7;0;0.7" dur="5s" repeatCount="indefinite" />
      </circle>
      {/* Score chip */}
      <rect x="143" y="48" width="34" height="14" rx="3" fill="#1f2421" stroke="#4aa198" strokeWidth="0.8" />
      <text x="160" y="58" fill="#bae6fd" fontSize="7" fontFamily="monospace" fontWeight="bold" textAnchor="middle">fit: 9/10</text>

      {/* Target B */}
      <circle cx="205" cy="115" r="3" fill="#7dd3fc">
        <animate attributeName="opacity" values="0.4;1;0.4" dur="6s" repeatCount="indefinite" begin="2s" />
      </circle>
      <circle cx="205" cy="115" r="7" fill="none" stroke="#7dd3fc" strokeWidth="1" opacity="0.4">
        <animate attributeName="r" values="3;10;3" dur="6s" repeatCount="indefinite" begin="2s" />
        <animate attributeName="opacity" values="0.5;0;0.5" dur="6s" repeatCount="indefinite" begin="2s" />
      </circle>

      {/* Target C */}
      <circle cx="170" cy="48" r="2.5" fill="#9bc4b5" opacity="0.6" />
    </g>

    {/* Center crosshair */}
    <g stroke="#9bc4b5" strokeWidth="1" opacity="0.4">
      <line x1="160" y1="75" x2="160" y2="101" />
      <line x1="147" y1="88" x2="173" y2="88" />
    </g>
    <circle cx="160" cy="88" r="6" fill="none" stroke="#9bc4b5" strokeWidth="1.5" opacity="0.6" />
    <circle cx="160" cy="88" r="2" fill="#9bc4b5" opacity="0.9" />

    {/* Right panel — live feed */}
    <rect x="270" y="24" width="112" height="130" rx="8" fill="#061020" stroke="#1e3a5c" strokeWidth="1" />
    <text x="285" y="42" fill="#475569" fontSize="7" fontFamily="monospace">LIVE SIGNALS</text>
    <line x1="270" y1="48" x2="382" y2="48" stroke="#1e3a5c" strokeWidth="0.7" />
    {[
      { y: 62, name: 'Acme Corp', score: '9.2', color: '#34d399' },
      { y: 82, name: 'BuildFast Inc', score: '7.8', color: '#60a5fa' },
      { y: 102, name: 'GrowthLab', score: '6.5', color: '#60a5fa' },
      { y: 122, name: 'Shopify Plus', score: '5.1', color: '#94a3b8' },
    ].map(({ y, name, score, color }) => (
      <g key={name}>
        <circle cx="283" cy={y - 3} r="2" fill={color} />
        <text x="291" y={y} fill="#94a3b8" fontSize="7" fontFamily="monospace">{name}</text>
        <text x="374" y={y} fill={color} fontSize="7" fontFamily="monospace" textAnchor="end" fontWeight="bold">{score}</text>
        <line x1="282" y1={y + 5} x2="380" y2={y + 5} stroke="#1e3a5c" strokeWidth="0.5" />
      </g>
    ))}
    <rect x="278" y="133" width="96" height="12" rx="3" fill="#0c2a4a" />
    <rect x="278" y="133" width="72" height="12" rx="3" fill="#0369a1">
      <animate attributeName="width" values="0;72;72" dur="5.5s" repeatCount="indefinite" />
    </rect>
    <text x="326" y="142" fill="#bae6fd" fontSize="6" fontFamily="monospace" textAnchor="middle">scanning...</text>
  </svg>
);

export const AiScoringAnim = () => (
  <svg viewBox="0 0 400 176" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="ai-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#09090b" />
        <stop offset="100%" stopColor="#160d30" />
      </linearGradient>
      <radialGradient id="ai-core-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#216869" stopOpacity="0.35" />
        <stop offset="100%" stopColor="#216869" stopOpacity="0" />
      </radialGradient>
    </defs>

    <rect width="400" height="176" fill="url(#ai-bg)" />

    {/* Core glow */}
    <circle cx="200" cy="88" r="60" fill="url(#ai-core-glow)" />

    {/* Neural connections */}
    <g stroke="#4338ca" strokeWidth="1" opacity="0.5">
      <line x1="70" y1="44" x2="200" y2="88" />
      <line x1="70" y1="132" x2="200" y2="88" />
      <line x1="200" y1="88" x2="330" y2="42" />
      <line x1="200" y1="88" x2="330" y2="134" />
    </g>

    {/* Flowing particles on connections */}
    {[
      { path: "M70 44 L200 88", dur: "5.5s", delay: "0s" },
      { path: "M70 132 L200 88", dur: "6.2s", delay: "1.6s" },
      { path: "M200 88 L330 42", dur: "5s", delay: "0.8s" },
      { path: "M200 88 L330 134", dur: "5.8s", delay: "2.2s" },
    ].map(({ path, dur, delay }, i) => (
      <circle key={i} r="2.5" fill="#a5b4fc">
        <animateMotion path={path} dur={dur} repeatCount="indefinite" begin={delay} />
      </circle>
    ))}

    {/* Left input nodes */}
    <g>
      <circle cx="70" cy="44" r="12" fill="#1e1b4b" stroke="#4f46e5" strokeWidth="1.5" />
      <text x="70" y="48" fill="#a5b4fc" fontSize="8" textAnchor="middle" fontFamily="monospace">B2B</text>

      <circle cx="70" cy="132" r="12" fill="#1e1b4b" stroke="#4f46e5" strokeWidth="1.5" />
      <text x="70" y="136" fill="#a5b4fc" fontSize="7" textAnchor="middle" fontFamily="monospace">ICP</text>
    </g>

    {/* Central AI node */}
    <circle cx="200" cy="88" r="26" fill="#1e1b4b" stroke="#818cf8" strokeWidth="2" />
    <circle cx="200" cy="88" r="32" fill="none" stroke="#4f46e5" strokeWidth="1" strokeDasharray="4 5" opacity="0.5">
      <animateTransform attributeName="transform" type="rotate" from="0 200 88" to="360 200 88" dur="22s" repeatCount="indefinite" />
    </circle>
    <text x="200" y="85" fill="#ffffff" fontSize="9" textAnchor="middle" fontFamily="monospace" fontWeight="bold">AI</text>
    <text x="200" y="96" fill="#a5b4fc" fontSize="6" textAnchor="middle" fontFamily="monospace">scoring</text>

    {/* Right output nodes with scores */}
    <g>
      <circle cx="330" cy="42" r="16" fill="#1e1b4b" stroke="#34d399" strokeWidth="2" />
      <text x="330" y="39" fill="#34d399" fontSize="11" textAnchor="middle" fontWeight="bold">9.4</text>
      <text x="330" y="50" fill="#6ee7b7" fontSize="5.5" textAnchor="middle" fontFamily="monospace">PRIORITY</text>

      <circle cx="330" cy="134" r="14" fill="#1e1b4b" stroke="#60a5fa" strokeWidth="1.5" />
      <text x="330" y="131" fill="#93c5fd" fontSize="10" textAnchor="middle" fontWeight="bold">6.7</text>
      <text x="330" y="142" fill="#93c5fd" fontSize="5" textAnchor="middle" fontFamily="monospace">REVIEW</text>
    </g>

    {/* Status bar */}
    <rect x="120" y="144" width="120" height="18" rx="4" fill="#0f0a1e" stroke="#312e81" strokeWidth="0.8" />
    <text x="131" y="156" fill="#216869" fontSize="6.5" fontFamily="monospace">ANALYZING INTENT...</text>
    <circle cx="237" cy="153" r="2.5" fill="#4f46e5">
      <animate attributeName="opacity" values="1;0.2;1" dur="3s" repeatCount="indefinite" />
    </circle>
  </svg>
);

export const OutreachAnim = () => (
  <svg viewBox="0 0 400 176" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="or-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f0520" />
        <stop offset="100%" stopColor="#1a0938" />
      </linearGradient>
    </defs>

    <rect width="400" height="176" fill="url(#or-bg)" />

    {/* Subtle horizontal grid lines */}
    <g stroke="#2d1b5c" strokeWidth="0.5" opacity="0.5">
      {[44, 88, 132].map(y => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}
    </g>

    {/* Main sequence path */}
    <path
      d="M 60 88 C 110 88, 150 50, 200 88 C 250 126, 290 88, 340 88"
      fill="none" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" opacity="0.4"
    />
    <path
      d="M 60 88 C 110 88, 150 50, 200 88 C 250 126, 290 88, 340 88"
      fill="none" stroke="#c4b5fd" strokeWidth="1.5" strokeDasharray="5 10" strokeLinecap="round"
    >
      <animate attributeName="stroke-dashoffset" values="0;-60" dur="7s" repeatCount="indefinite" />
    </path>

    {/* Traveling envelopes */}
    {[
      { dur: "7s", delay: "0s" },
      { dur: "7s", delay: "3s" },
    ].map(({ dur, delay }, i) => (
      <g key={i}>
        <animateMotion path="M60 88 C110 88, 150 50, 200 88 C250 126, 290 88, 340 88" dur={dur} repeatCount="indefinite" begin={delay} />
        <rect x="-9" y="-7" width="18" height="14" rx="2.5" fill="#3b0764" stroke="#a78bfa" strokeWidth="1.2" />
        <path d="M-7 -5 L0 1 L7 -5" fill="none" stroke="#ddd6fe" strokeWidth="1" strokeLinecap="round" />
      </g>
    ))}

    {/* Step nodes */}
    {/* Start */}
    <circle cx="60" cy="88" r="14" fill="#1e0743" stroke="#7c3aed" strokeWidth="2" />
    <text x="60" y="92" fill="#c4b5fd" fontSize="8" textAnchor="middle" fontWeight="bold" fontFamily="monospace">IN</text>

    {/* Step 1 — LinkedIn */}
    <circle cx="168" cy="58" r="13" fill="#1e0743" stroke="#a78bfa" strokeWidth="1.5" />
    <path d="M162 55 C162 52 165 50 168 50 C171 50 174 52 174 55 L174 64 L162 64 Z" fill="#c4b5fd" opacity="0.7" />
    <text x="168" y="62" fill="#ede9fe" fontSize="5" textAnchor="middle" fontFamily="monospace">LI</text>
    {/* check pulse */}
    <circle cx="178" cy="50" r="5" fill="#1e0743" stroke="#34d399" strokeWidth="1">
      <animate attributeName="opacity" values="1;0.3;1" dur="4.5s" repeatCount="indefinite" />
    </circle>
    <path d="M175 50 L177 52 L181 48" fill="none" stroke="#34d399" strokeWidth="1.2" strokeLinecap="round" />

    {/* Step 2 — Email */}
    <circle cx="232" cy="118" r="13" fill="#1e0743" stroke="#a78bfa" strokeWidth="1.5" />
    <rect x="225" y="113" width="14" height="10" rx="2" fill="none" stroke="#c4b5fd" strokeWidth="1.2" opacity="0.8" />
    <path d="M225 115 L232 120 L239 115" fill="none" stroke="#c4b5fd" strokeWidth="1" strokeLinecap="round" opacity="0.8" />
    <circle cx="242" cy="110" r="5" fill="#1e0743" stroke="#34d399" strokeWidth="1">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="4.5s" repeatCount="indefinite" begin="1.8s" />
    </circle>
    <path d="M239 110 L241 112 L245 108" fill="none" stroke="#34d399" strokeWidth="1.2" strokeLinecap="round" />

    {/* End — Reply detected */}
    <circle cx="340" cy="88" r="16" fill="#2e1065" stroke="#c4b5fd" strokeWidth="2" />
    <circle cx="340" cy="88" r="22" fill="none" stroke="#7c3aed" strokeWidth="1" opacity="0.4">
      <animate attributeName="r" values="16;24;16" dur="5.5s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.4;0;0.4" dur="5.5s" repeatCount="indefinite" />
    </circle>
    <text x="340" y="85" fill="#ede9fe" fontSize="7" textAnchor="middle" fontFamily="monospace">REPLY</text>
    <text x="340" y="95" fill="#a78bfa" fontSize="6" textAnchor="middle" fontFamily="monospace">detected</text>

    {/* Status badge */}
    <rect x="130" y="148" width="100" height="16" rx="4" fill="#0a0420" stroke="#4c1d95" strokeWidth="0.8" />
    <circle cx="142" cy="156" r="3" fill="#34d399">
      <animate attributeName="opacity" values="1;0.3;1" dur="3.2s" repeatCount="indefinite" />
    </circle>
    <text x="150" y="160" fill="#a78bfa" fontSize="7" fontFamily="monospace">CAMPAIGN RUNNING</text>
  </svg>
);
